<script>
  import DataTable from '../DataTable/DataTable.svelte';
  import Loader from '../Loader.svelte';
  import InfoAlert from '../Alert/InfoAlert.svelte';
  import { client } from 'root/api/index.js';
  import Select from 'svelte-select';
  import * as yup from 'yup';
  import { Modal } from 'bootstrap';
  import { createForm } from 'svelte-forms-lib';
  import FormInput from '../FormControls/FormInput.svelte';
  import { getContext, onMount } from 'svelte';
  import { configItem } from '../../components/Helper';
  import { getMasterData, setMasterData } from '../../stores/masterData';
  export let unitId;
  export let parentColumn;

  let defaultValue = {
    id: '',
    name: '',
    parentId: undefined,
    unitId,
  };

  let isFormPending = false;
  let serverErrors = [];
  let parent = [];
  let selectedParentId = null;

  const showDialog = getContext('showDialog');

  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      name: yup.string().required('Type name is required'),
      parentId: yup.string(),
    }),
    onSubmit: (values) => {
      isFormPending = true;
      client
        .clientTypeAdd({ ...values, unitId })
        .then((response) => {
          isFormPending = false;
          toggleModal('hide');
          filterData();
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
        });
    },
  });

  let getData = (queries) => {
    return client.clientTypeList(50, 1, {
      ...queries,
      ...extraFilter,
    });
  };

  let datatableRef;
  let scrollRef;
  let columns = [
    { key: 'name', label: 'Type Name', sortable: true },
    { key: 'parentName', label: 'Parent', sortable: true },
    { key: 'active', label: 'Status', sortable: true },
    { key: 'action', label: 'Action', sortable: false },
  ];

  let defaultFilter = {
    searchKeyword: '',
    unitId: unitId,
  };
  let extraFilter = { ...defaultFilter };

  let searchTimeout;
  let firstTimeLoad = true;
  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        if (firstTimeLoad) {
          firstTimeLoad = false;
          return false;
        }
        datatableRef.initializeState();
      }
    }, 250);
  };

  $: unitId && changeUnitId();
  $: extraFilter && filterData();

  function changeUnitId() {
    const index = columns.findIndex((x) => x.key == 'parentName');
    if (parentColumn && index == -1) {
      columns.splice(1, 0, {
        key: 'parentName',
        label: 'Parent',
        sortable: true,
      });
    } else if (!parentColumn && index == 1) {
      columns.splice(index, 1);
    }

    $form = { ...defaultValue };
    extraFilter.unitId = unitId;
  }

  function toggleModal(flag) {
    if (flag != undefined && flag == 'hide') {
      var modal = Modal.getInstance(document.getElementById('clientTypeModal'));
      modal.hide();
    } else {
      var modal = new Modal(document.getElementById('clientTypeModal'), {
        keyboard: false,
        backdrop: 'static',
      });
      modal.show();
    }
  }

  let focusInput;
  onMount(() => {
    document.getElementById('clientTypeModal').addEventListener('shown.bs.modal', function () {
      focusInput.focusOnInput();
    });
  });

  function showDelete(selectId) {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure?',
      okFunc: () => {
        client
          .clientTypeDelete({ id: selectId })
          .then((response) => {
            filterData();
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  }

  function getDetail(id) {
    $form = { ...defaultValue };
    $errors = {};
    selectedParentId = null;
    serverErrors = [];
    client
      .clientTypeParentList({ unitId })
      .then((response) => {
        parent = response.data.payload;
      })
      .catch((err) => {});

    if (id > 0) {
      client
        .clientTypeDetail({ id })
        .then((response) => {
          $form = response.data;
          if (response.data.parentId != '') {
            selectedParentId = {
              id: $form.parentId,
              name: response.data.parentName,
            };
          } else {
            selectedParentId = null;
          }
          toggleModal();
        })
        .catch((err) => {});
    } else {
      toggleModal();
    }
  }
</script>

<div class="p-3 h-100 d-flex flex-column">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h3 class="font-size-14 mb-0">Client Type</h3>
    <button
      on:click={() => getDetail(0)}
      class="mb-0 px-4 font-size-13 background-blue text-white rounded border-blue btn-primary shadow-none"
      >+ Add Client Type</button
    >
  </div>
  <div
    class="ibox-content page-content mt-3"
    bind:this={scrollRef}
  >
    <DataTable
      bind:this={datatableRef}
      columns={columns}
      scrollRef={scrollRef}
      getData={getData}
      let:row
    >
      <td class="text-muted"><span class="text-break">{row.name}</span></td>
      {#if parentColumn}
        <td
          class="text-muted"
          width="200">{row.parentName}</td
        >
      {/if}
      <td width="110">
        <div class="form-check form-switch status-switch-block">
          <input
            id={row.id}
            checked={row.active === configItem.status.active}
            class="form-check-input shadow-none"
            type="checkbox"
            on:change={(event) => {
              client
                .clientTypeUpdateStatus({ id: row.id })
                .then((result) => {
                  row.active = event.target.checked
                    ? configItem.status.active
                    : configItem.status.inactive;

                  let masterData = getMasterData();
                  let foundItem = false;
                  masterData.clientTypes = masterData.clientTypes.map(function (item) {
                    if (foundItem == false) {
                      if (item.id == row.id) {
                        item.active = row.active;
                        foundItem = true;
                      }
                      item.subClientTypes = item.subClientTypes.map(function (subItem) {
                        if (subItem.id == row.id) {
                          subItem.active = row.active;
                          foundItem = true;
                        }
                        return subItem;
                      });
                    }
                    return item;
                  });
                  setMasterData(masterData);
                })
                .catch((error) => {
                  event.target.checked = row.active === configItem.status.active;
                  showDialog({ message: error.message });
                });
            }}
          />
        </div>
      </td>
      <td
        class="text-muted"
        width="80"
      >
        <button
          class="btn btn-link shadow-none border-0 bg-transparent py-0 px-2"
          on:click={() => getDetail(row.id)}
        >
          <img
            class=" icon-16"
            alt=""
            src="/images/pencil-gray.svg"
          />
        </button>
        <button
          class="btn btn-link shadow-none border-0 bg-transparent p-0"
          on:click={() => showDelete(row.id)}
        >
          <img
            class=" icon-16"
            alt=""
            src="/images/cancel.svg"
          />
        </button>
      </td>
    </DataTable>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="clientTypeModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="clientTypeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5
          class="modal-title font-size-14"
          id="clientTypeModalLabel"
        >
          {$form.id != undefined && $form.id > 0 ? 'Edit' : 'Add'} Client Type
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <InfoAlert
          type="error"
          message={serverErrors}
          customStyle="alert  text-white w-100 mb-3"
        />
        <div class="row">
          {#if parentColumn}
            <div class="col-md-6">
              <div class="form-group mb-3 select-block">
                <label
                  for=""
                  class="form-label">Select Parent</label
                >
                <Select
                  showChevron={true}
                  isClearable={true}
                  bind:selectedValue={selectedParentId}
                  items={parent}
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  on:select={(ev) => {
                    $form.parentId = ev.detail.id;
                  }}
                  on:clear={(ev) => {
                    $form.parentId = undefined;
                  }}
                  optionIdentifier="id"
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                ></Select>
              </div>
            </div>
          {/if}
          <div class={parentColumn ? 'col-md-6' : 'col-md-12'}>
            <div class="form-group mb-3">
              <FormInput
                keypress={(event) => {
                  if (event.key == 'Enter') {
                    handleSubmit();
                  }
                }}
                name="name"
                label="Type name"
                type="text"
                maxLength={configItem.maxLength.masterInput}
                placeholder="Enter type name"
                handleChange={handleChange}
                error={$errors.name}
                bind:value={$form.name}
                bind:this={focusInput}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button
          on:click={handleSubmit}
          type="button"
          class="btn btn-primary font-size-13 px-4"
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else}Save{/if}
        </button>
      </div>
    </div>
  </div>
</div>
